export const printFontFamily = (item) => [item.fontFamily, ...item.fontFamilyFallbacks]
	.map(f => f.includes(' ') ? `'${f}'` : f)
	.join(', ')